import { usePrefetchedSuspenseQuery } from "@-/com.npmjs.tanstack__react-query";
import type { LearnSummaryPageResolution } from "#learn-summary-page-resolution";
import { useLearnSummaryPageQueryOptions } from "#use-learn-summary-page-query-options";

/**
 * The local (non-content-validated) learn summary resolution. `LearnSummaryPageSuspense` observes the
 * same query with its own loading / error / unavailable branches and only renders the page content
 * once it has data, so inside the content this is a cache hit that never suspends.
 */
export function useLearnSummaryResolutionSuspense(): LearnSummaryPageResolution {
  return usePrefetchedSuspenseQuery(useLearnSummaryPageQueryOptions()).data;
}
